
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"comparableByTransactionId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"transaction_ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comparableByTransactionId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"transaction_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transaction_ids"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transaction_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"geometry"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coordinates"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"post_code"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date_of_transfer"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"designation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"category"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sub_category"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_new_property"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tenure"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"price"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"total_floor_area"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"price_per_square_metre"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"est_price_per_square_metre"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"num_bedrooms"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"est_bedrooms"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"number_habitable_rooms"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"est_price"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uprn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"country"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currency"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"prev_transactions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transaction_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date_of_transfer"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"price"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currency"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"epc"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current_energy_rating"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"potential_energy_rating"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"current_energy_efficiency"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"potential_energy_efficiency"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":756}};
    doc.loc.source = {"body":"query comparableByTransactionId($transaction_ids: [String!]!) {\n  comparableByTransactionId(transaction_ids: $transaction_ids) {\n    transaction_id\n    geometry {\n      coordinates\n    }\n    address\n    post_code\n    date_of_transfer\n    designation\n    category\n    sub_category\n    is_new_property\n    tenure\n    price\n    total_floor_area\n    price_per_square_metre\n    est_price_per_square_metre\n    num_bedrooms\n    est_bedrooms\n    number_habitable_rooms\n    est_price\n    uprn\n    country\n    currency\n    prev_transactions {\n      transaction_id\n      date_of_transfer\n      price\n      currency\n    }\n    epc {\n      current_energy_rating\n      potential_energy_rating\n      current_energy_efficiency\n      potential_energy_efficiency\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["comparableByTransactionId"] = oneQuery(doc, "comparableByTransactionId");
        
